<script lang="ts">
    
    import { createEventDispatcher, getContext } from "svelte";
    import type { Writable } from "svelte/store";
    import { Button, Icon, Offcanvas } from "sveltestrap";
    import type { Game } from "../../Model/Game";
    import type { User } from '../../Model/User'
    import { meService } from "../../Services";
    import { i18n } from "../../Services/i18n";
  import LangSelect from "../Shared/LangSelect.svelte"

    export let isOpen: boolean;
    export let toggle: () => any;

    const dispatch = createEventDispatcher();
    const gameStore: Writable<Game | null> = getContext('gameStore');
    const me = meService.me

    let appState: string = '';

    $: createGameStateString($gameStore, $me);

    function onLogout(): void {
        dispatch('logout');
    }

    async function createGameStateString(game: Game | null, me: User | null): Promise<void> {
        if (!me) {
            return
        }

        let state: string[] = [];

        if (!game) {
            state.push(
                'Actualmente sin partida creada.'
            )
        } else {
            state.push(
                `Game type: ${game.type}`,
                `Game checkers: ${game.useCheckers?.join(', ') || 'Ninguno'}`,
                `Game state: ${game.state.value}`,
                `Game Id: ${game.id}`,
                `Room Id: ${game.roomId}`
            );
        }

        state.push(
            `User Id: ${me.id}`,
            `Account Id: ${me.accountId || 'Ninguna'}`,
            `User Agent: ${window.navigator.userAgent}`,
            `Screen size: ${window.innerWidth}x${window.innerHeight}`
        );

        appState = encodeURIComponent(state.join('\n'));
    }

</script>

<Offcanvas {isOpen} {toggle} placement="end" class="manager-menu">
    <div class="content">
        <div class="main">
            <slot />
        </div>
        <div class="footer">

            <div style="width: 100%;">
                <small>{$i18n('Seleccione su idioma')}</small><br>
                <LangSelect />
            </div>

            <!-- <div class="incidence-link">
                <a target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSet2MINn0pBDcmUMXeFYNytqJnRHG_G46ToUiLHgoLgIPBHwg/viewform?usp=pp_url&entry.1640927073={appState}">
                    <strong>{$i18n("Comunicar incidencia")}</strong>
                </a>
            </div> -->

            <Button type="button" color="danger" block on:click={onLogout}>
                <Icon name="power" /> {$i18n("Salir")}
            </Button>
        </div>
    </div>
</Offcanvas>

<style lang="scss">

    :global(.manager-menu) {
        background-color: var(--color-primary);
        color: #fff;

        :global(.btn-close) {
            /* filter: invert(1); */
            display: none;
        }
    }

    .content {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .main {
        flex: 1 1 0;
    }

    .footer {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
    }

    .incidence-link {
        display: block;
        padding: 0.5rem;
        background-color: #fff;
        border-radius: 0.25rem;
        text-align: center;
    }

</style>
